module.exports = __webpack_public_path__ + "static/media/spot7.e2daabfd.webp";